import { useEffect, useState } from 'react';
import { getPAAAA010quick, putPAAAA010Banner, putPAAAA010ClickBanner } from '../../services/Api';
import ImageCheckFallback from './ImageCheckFallback';

const SideBanners = () => {
    const [dataBanner, setDataBanner] = useState([]);
    const [dataBannerMainTop, setDataBannerMainTop] = useState(null);

    useEffect(() => {
        getPAAAA010quick()
            .then(({ data }) => {
                setDataBanner(data.quick);
                data.mainTop !== null && setDataBannerMainTop(data.mainTop);
                if (data?.quick?.length > 0) {
                    const listSeq = [data.quick?.map((item) => item.seq).join(',')].filter((seq) => seq).join(',');
                    if (listSeq.toString() === '') return;
                    putPAAAA010Banner(listSeq.toString())
                        .then()
                        .catch((error) => console.log(error));
                }
            })
            .catch((error) => console.log(error));
    }, []);

    useEffect(() => {
        const sideBanners = document.getElementById('sideBanners');
        if (!sideBanners) return;

        const offsetTop =
            dataBannerMainTop === null
                ? 190
                : document.getElementById('topBanner')?.offsetHeight +
                  document.getElementById('header')?.offsetHeight +
                  document.getElementById('navbar')?.offsetHeight +
                  20;

        function calculateLeftPos() {
            const container = document.querySelector('.container');
            if (!container) return 0;
            const containerWidth = container.offsetWidth;
            const marginLeft = parseInt(window.getComputedStyle(container).marginLeft, 10);
            return containerWidth + 30 + marginLeft;
        }

        let leftPos = calculateLeftPos();
        let currentTop = offsetTop;
        let targetTop = offsetTop;
        let ticking = false;

        sideBanners.style.position = 'absolute';
        sideBanners.style.top = `${offsetTop}px`;
        sideBanners.style.left = `${leftPos}px`;

        const smoothMove = () => {
            currentTop += (targetTop - currentTop) * 0.1;
            sideBanners.style.top = `${currentTop}px`;

            if (Math.abs(targetTop - currentTop) > 0.5) {
                requestAnimationFrame(smoothMove);
            } else {
                ticking = false;
            }
        };

        const handleScroll = () => {
            const scrollY = window.scrollY;
            leftPos = calculateLeftPos();

            targetTop = scrollY + 60;

            if (targetTop < offsetTop) targetTop = offsetTop;

            sideBanners.style.left = `${leftPos}px`;

            if (!ticking) {
                ticking = true;
                requestAnimationFrame(smoothMove);
            }
        };

        const handleResize = () => {
            leftPos = calculateLeftPos();
            sideBanners.style.left = `${leftPos}px`;
        };

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, [dataBannerMainTop]);

    return (
        <div id="sideBanners">
            <div className="side-banner-wrap">
                {dataBanner &&
                    dataBanner.map((item, index) => {
                        return (
                            <div className="side-banner-item" key={`side-banner-${index}`}>
                                <a
                                    href={item?.linkUrl}
                                    rel="nofollow"
                                    target={item?.linkType === 'window' ? '_self' : item?.linkType}
                                    onClick={async (e) => {
                                        if (item?.linkType !== '_blank') {
                                            e.preventDefault();
                                        }
                                        await putPAAAA010ClickBanner(item?.seq);
                                        try {
                                            if (item?.linkType === 'window') {
                                                window.open(item?.linkUrl, '_blank', 'width=800,height=600');
                                            } else if (item?.linkType !== '_blank') {
                                                window.location.href = item?.linkUrl;
                                            }
                                        } catch (error) {
                                            console.log(error);
                                        }
                                    }}
                                >
                                    <ImageCheckFallback
                                        folderName={'banner_photo_quick'}
                                        imgName={item?.imgNameMain}
                                        alt="Side Banner"
                                        classImg={'topApds-img'}
                                    />
                                </a>
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

export default SideBanners;
